<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <h5 class="border-bottom pb-2 mb-2">{{'trigManage.aggregatedreportsforadmin' | translate}}</h5>
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>

      <div class="col-12 col-xl col-md-6">
        <div>
          <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="formInputfilter['ay']" class="form-control custom-selectbox">
            <option value="" [disabled]="true">{{'trigManage.selectassessmentyear' | translate}}</option>
            <option *ngFor="let year of fieldDropDownList['AssesmentList']" value="{{year}}">{{year}}</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-xl col-md-6">
        <div>
          <label>{{'header.state' | translate }}<span class="required-field">*</span></label>
          <select placeholder="Select State" [(ngModel)]="selectedstate" (change)="showdistrictdropdown(selectedstate)"
            class="form-control custom-selectbox">
            <option value=undefined>{{'tabledataforstates.selectstate' | translate}}</option>
            <option *ngFor="let state of statelists" value="{{state['uuid']}}">
              {{'tabledataforstates.'+ state['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6">
        <div *ngIf="showdistdrop">
          <label>{{'header.district' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="selectedistrict" (change)="getdistuuid(selectedistrict)"
            class="form-control custom-selectbox">
            <option value="undefined">{{'trigManage.selectdistrict' | translate}}</option>
            <option *ngFor="let district of districtentityList" value="{{district['uuid']}}">
              {{ 'districtsdata.' + district['name'] | translate}}</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-xl col-md-6">
        <div>
          <label>{{'aggregatedpage.aggregatedscore' | translate}}<span class="required-field">*</span></label>
          <select [(ngModel)]="aggregatedScore" class="form-control custom-selectbox selectdis">
            <option value="undefined">{{'aggregatedpage.aggregatedscore' | translate}}</option>
            <option value="quaterlywise">{{'aggregatedpage.quat' | translate}}</option>
            <option value="halfearlywise">{{'aggregatedpage.half' | translate}}</option>
            <option value="annualwise">{{'aggregatedpage.annual' | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="aggregatedScore == 'quaterlywise'">
        <label class="text-nowrap">{{'aggregatedpage.Averages For Quarterly' | translate}}<span
            class="required-field">*</span></label>
        <select [(ngModel)]="quaterlyScore" (change)="typechanged()" class="form-control custom-selectbox selectdis">
          <option value="undefined">{{'aggregatedpage.selectavg' | translate}}</option>
          <option value="simpleaverage">{{'aggregatedpage.Simple Average' | translate}}</option>
          <option value="weightedaverage">{{'aggregatedpage.Weighted Average' | translate}}</option>
        </select>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="aggregatedScore == 'halfearlywise'">
        <label class="text-nowrap">{{"aggregatedpage.Averages For Half yearly" | translate}}<span
            class="required-field">*</span></label>
        <select [(ngModel)]="halfearlyScore" (change)="typeChanged()" class="form-control custom-selectbox selectdis">
          <option value="undefined">{{'aggregatedpage.selectavg' | translate}}</option>
          <option value="simpleaverage">{{'aggregatedpage.Simple Average' | translate}}</option>
          <option value="weightedaverage">{{'aggregatedpage.Weighted Average' | translate}}</option>
        </select>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="aggregatedScore == 'annualwise'">
        <label class="text-nowrap">{{'aggregatedpage.Averages For Annually' | translate}}<span
            class="required-field">*</span></label>
        <select [(ngModel)]="annuallyScore" (change)="typeChange()" class="form-control custom-selectbox selectdis">
          <option value="undefined">{{'aggregatedpage.selectavg' | translate}}</option>
          <option value="simpleaverage">{{'aggregatedpage.Simple Average' | translate}}</option>
          <option value="weightedaverage">{{'aggregatedpage.Weighted Average' | translate}}</option>
        </select>
      </div>
    </div>
    <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">
      <table class="table table-striped text-center table-sm mt-1">
        <thead class="thead-light">
          <tr *ngIf="aggregatedScore =='quaterlywise' && quaterlyScore == 'weightedaverage'">
            <th>{{'trigManage.sno' | translate}}</th>
            <th>{{'aggregatedpage.Enter The Quarterly Weighted Average Value' | translate}} X1 </th>
            <th>{{'aggregatedpage.Enter The Quarterly Weighted Average Value' | translate}} X2 </th>
            <th>{{'aggregatedpage.Enter The Quarterly Weighted Average Value' | translate}} X3 </th>
          </tr>
          <tr *ngIf="aggregatedScore =='halfearlywise' && halfearlyScore == 'weightedaverage'">
            <th>{{'trigManage.sno' | translate}}</th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X1 </th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X2 </th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X3 </th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X4 </th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X5</th>
            <th>{{'aggregatedpage.Enter The Half yearly Weighted Average Value' | translate}} X6</th>
          </tr>
          <tr *ngIf=" aggregatedScore =='annualwise' && annuallyScore == 'weightedaverage'">
            <th>{{'trigManage.sno' | translate}}</th>
            <th>Enter The Annually Weighted Average Value X1 </th>
            <th>Enter The Annually Weighted Average Value X2 </th>
            <th>Enter The Annually Weighted Average Value X3 </th>
            <th>Enter The Annually Weighted Average Value X4 </th>
            <th>Enter The Annually Weighted Average Value X5</th>
            <th>Enter The Annually Weighted Average Value X6</th>
            <th>Enter The Annually Weighted Average Value X7</th>
            <th>Enter The Annually Weighted Average Value X8</th>
            <th>Enter The Annually Weighted Average Value X9</th>
            <th>Enter The Annually Weighted Average Value X10 </th>
            <th>Enter The Annually Weighted Average Value X11</th>
            <th>Enter The Annually Weighted Average Value X12</th>
          </tr>
        </thead>
        <tbody class="text-white">
          <ng-container *ngIf="aggregatedScore =='quaterlywise' && quaterlyScore == 'weightedaverage'">
            <tr>
              <td>1</td>
              <td>
                <input class="input-style p-0" [(ngModel)]="quaterlyWeightedList['x1']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343"></td>
              <td>
                <input class="input-style p-0" [(ngModel)]="quaterlyWeightedList['x2']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="quaterlyWeightedList['x3']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
            </tr>
          </ng-container>
          <ng-container>
            <tr *ngIf="aggregatedScore =='halfearlywise' && halfearlyScore == 'weightedaverage'">
              <td></td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x1']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x2']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x3']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x4']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x5']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="halfyearlyWeightedList['x6']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
            </tr>
          </ng-container>
          <ng-container>
            <tr *ngIf="aggregatedScore =='annualwise' && annuallyScore == 'weightedaverage'">
              <td></td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x1']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x2']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x3']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x4']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x5']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x6']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x7']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x8']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x9']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x10']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x11']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
              <td>
                <input class="input-style p-0" [(ngModel)]="annuallyWightedList['x12']" name="comments" placeholder=""
                  style="width: 100px;" type="text" id="#13343">
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="text-center" *ngIf="quaterlyScore == 'weightedaverage' && aggregatedScore == 'quaterlywise'"
      style="margin-top: 20px;">
      <button class="btn btn-info pointer" (click)="getWeightedData()" style="margin-top:31px;" type="submit"
        [disabled]="disableedit">{{'misviewtabs.submit' | translate}}</button>
    </div>
    <div class="text-center" *ngIf="halfearlyScore == 'weightedaverage' && aggregatedScore == 'halfearlywise'"
      style="margin-top: 20px;">
      <button class="btn btn-info pointer" (click)="halfyearlyWeighteddata()" style="margin-top:31px;" type="submit"
        [disabled]="disableedit">{{'misviewtabs.submit' | translate}}</button>
    </div>
    <div class="text-center" *ngIf="annuallyScore == 'weightedaverage' && aggregatedScore == 'annualwise'"
      style="margin-top: 20px;">
      <button class="btn btn-info pointer" (click)="  annuallyWeightedData()" style="margin-top:31px;" type="submit"
        [disabled]="disableedit">{{'misviewtabs.submit' | translate}}</button>
    </div>
  </div>
</div>